import { IPoi } from "~/interfaces";
import Content from "./content";
import { getLocalChangesItems } from "~/util/providers/report-local-changes";
import { watch } from "~/state/util";
import { store } from "~/state/store";
import { watchReportChanges } from "~/state/report/selectors";
import { icon, node } from "~/util/dom";
import { _ } from "~/i18n";
import Tooltip, { ETooltipFlow } from "~/ui/tooltip";
import { CONFIG } from "~/config";

export default class ReportLocalChanges extends Content {
	_watcher: () => void;

	constructor(data, options) {
		super(data, options);

		if (Mapy.CUS.userweb?.reportLocalChanges) {
			this._watchChanges();
			this._buildFromStoreData();
		} else {
			this._dom.container.classList.remove("empty");
		}
	}

	_build() {
		this._dom.container.classList.add("content-reportLocChang");
	}

	_watchChanges() {
		// sledujeme zmeny
		const wt = watch(store.getState, "report", watchReportChanges);

		this._watcher = store.subscribe(wt(() => {
			this._buildFromStoreData();
		}));
	}

	destroy() {
		this._watcher && this._watcher();
	}

	_buildFromStoreData() {
		const poiData: IPoi = this._data;
		const data = getLocalChangesItems(poiData.source, poiData.id as number);

		this._dom.container.innerHTML = "";
		this._dom.container.classList.remove("empty");

		if (data) {
			const info = node("div", { className: "content-reportLocChang__info" });
			const desc = node("div", { className: "content-reportLocChang__desc" });

			info.append(icon("report-edit-location"));
			info.append(desc);
			desc.append(
				node("span", {
					className: "content-reportLocChang__title",
					innerHTML: _("report.localChanges.changesAwait", {
						start: `<span class="content-reportLocChang__green">`,
						end: `</span>`,
					}),
				}),
				node("span", {
					className: "content-reportLocChang__date",
					innerHTML: _("report.localChanges.editDate", {
						date: new Intl.DateTimeFormat(CONFIG.defaultLang, { year: "numeric", month: "long", day: "numeric" }).format(new Date(data.date)),
					}),
				}),
			);
			this._dom.container.append(info);

			if (data.items.length > 0) {
				const tooltipCont = node("div", { className: "content-reportLocChang__tooltipCont" });

				for (const item of data.items) {
					const elem = node("p", { textContent: item.value ? `${item.title}: ${item.value}` : item.title, className: "content-reportLocChang__tooltipItem" });

					tooltipCont.append(elem);
				}

				/* eslint-disable-next-line */
				const tooltip = new Tooltip({
					anchor: info,
					trigger: info,
					triggerEventType: "pointerenter",
					content: tooltipCont,
					arrow: true,
					width: 320,
					flow: ETooltipFlow.START,
					offset: [0, 0, 4, 0],
					className: "content-reportLocChang__tooltip",
					hideTimeout: 0,
				});
			}
		} else {
			this._dom.container.classList.add("empty");
		}
	}
}
